import { CanMatchFn } from '@angular/router';

// Lets phone-only routes (e.g. app hand-off pages) match; desktop falls through to the next route.
export const mobileDeviceGuard: CanMatchFn = () =>
  /iphone|ipad|ipod|android/i.test(navigator.userAgent);
